import React from 'react';

export const getProgressDescription = ({tt, percent, hasNextRank}: any) => {
  let progressDescription = '';

  // Parse and format percent: whole number no decimals, decimals with 2 digits
  const pct = parseFloat(percent);
  const formattedPercent = pct % 1 === 0 ? pct.toString() : pct.toFixed(2);

  if (hasNextRank) {
    progressDescription = tt('percentToNextRank', () => (
      <>{formattedPercent}% of the way to your next rank</>
    ));
  } else {
    progressDescription = tt('highestRankAchieved', 'Highest Rank Achieved');
  }

  return progressDescription;
};

export const getCurrentPercent = ({percent, hasNextRank}: any) =>
  hasNextRank ? percent : 100;
